import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../../common';
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';

import { RestorePoints } from './restore-points/restore-points.component';
import { DeleteRestore } from './delete-restore/delete-restore.component';
import { RefreshRestore } from './refresh-restore/refresh-restore.component';
import { StorageComparator } from './restore-points/restore-point-storage-comparator';
import { StorageRenderPipe, StatusStringFormatterPipe, DateRendererPipe } from './restore-points/restore-points.pipe';
import { InPlaceRestore } from './in-place-restore/in-place-restore.component';
import { OutOfPlaceRestoreModule } from './out-of-place-restore/out-of-place-restore.module';

@NgModule({
    declarations: [
        RestorePoints,
        DeleteRestore,
        RefreshRestore,
        InPlaceRestore,
        StorageRenderPipe,
        StatusStringFormatterPipe,
        DateRendererPipe
    ],
    imports: [
        BrowserModule,
        FormsModule,
        VcaCommonModule,
        TranslateModule,
        ClarityModule.forRoot(),
        Ng2DatetimePickerModule,
        OutOfPlaceRestoreModule
    ],
    providers: [],
    exports: [
        RestorePoints,
        DeleteRestore,
        RefreshRestore,
        InPlaceRestore,
        StorageRenderPipe,
        StatusStringFormatterPipe,
        DateRendererPipe
    ]

})
export class DpsOpsCommonModule {
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/common-ops.component.ts